import { render, staticRenderFns } from "./ManageService.vue?vue&type=template&id=157e4e64&scoped=true&"
import script from "./ManageService.vue?vue&type=script&lang=js&"
export * from "./ManageService.vue?vue&type=script&lang=js&"
import style0 from "./ManageService.vue?vue&type=style&index=0&id=157e4e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e4e64",
  null
  
)

export default component.exports